<br />
<div class="row">
  <div class="col-md-10 offset-md-2 text-left  col-12">
    <h1 class="title">
      <span>REPORTS: <strong>{{activeProjectTitle}}</strong></span>
    </h1>
  </div>
</div>
<br />
<div class="row">
  <div class="col-md-2"></div>
  <div class="col-md-8 col-12">
    <div class="row d-none d-sm-none d-md-block">
      <div class="btn-group" role="group" aria-label="Report Types">
        <button type="button" class="btn btn-primary" [ngClass]="reportId == 1 ?'btn-danger': 'btn-light'" (click)="selectReport(1)">Kappa Report</button>
        <button type="button" class="btn btn-primary" [ngClass]="reportId == 2 ?'btn-danger': 'btn-light'" (click)="selectReport(2)">Abstract Summary Report</button>
        <button type="button" class="btn btn-primary" [ngClass]="reportId == 3 ?'btn-danger': 'btn-light'" (click)="selectReport(3)">Abstract Values Download</button>
        <!-- <button type="button" class="btn btn-primary" [ngClass]="reportId == 4 ?'btn-danger': 'btn-light'" (click)="selectReport(4)">Weekly Coder Report</button> -->
        <button type="button" class="btn btn-primary" [ngClass]="reportId == 5 ?'btn-danger': 'btn-light'" (click)="selectReport(5)">QC Completed Report</button>
        <button type="button" class="btn btn-primary" [ngClass]="reportId == 6 ?'btn-danger': 'btn-light'" (click)="selectReport(6)">Recon. Completed Report</button>
      </div>
    </div>
    <div class="row  d-block d-sm-block d-md-none d-lg-none d-xl-none">
      <div class="row">
        <div class="col-10 offset-1 text-center">
          <button type="button" class="btn  btn-block" [ngClass]="reportId == 1 ?'btn-danger': 'btn-primary'" (click)="selectReport(1)">Kappa Report</button>
          <br />
        </div>
      </div>
      <div class="row">
        <div class="col-10 offset-1 text-center">
          <button type="button" class="btn btn-block" [ngClass]="reportId == 2 ?'btn-danger': 'btn-primary'" (click)="selectReport(2)">Abstract Summary Report</button>
          <br />
        </div>
      </div>
      <div class="row">
        <div class="col-10 offset-1 text-center">
          <button type="button" class="btn btn-block" [ngClass]="reportId == 3 ?'btn-danger': 'btn-primary'" (click)="selectReport(3)">Abstract Values Download</button>
          <br />
        </div>
      </div>
      <!-- <div class="row">
      <div class="col-10 offset-1 text-center">
        <button type="button" class="btn btn-block" [ngClass]="reportId == 4 ?'btn-danger': 'btn-primary'" (click)="selectReport(4)">Weekly Coder Report</button>
        <br />
      </div>
    </div> -->
      <div class="row">
        <div class="col-10 offset-1 text-center">
          <button type="button" class="btn btn-block" [ngClass]="reportId == 5 ?'btn-danger': 'btn-primary'" (click)="selectReport(5)">QC Completed - Coding Results</button>
        </div>
      </div>
      <div class="row">
        <div class="col-10 offset-1 text-center">
          <button type="button" class="btn btn-block" [ngClass]="reportId == 5 ?'btn-danger': 'btn-primary'" (click)="selectReport(5)">Recon. Completed Report</button>
        </div>
      </div>
      <br />
    </div>
    <br />
    <app-report-kappa *ngIf="reportId == 1"></app-report-kappa>
    <app-report-abstract-summary *ngIf="reportId == 2"></app-report-abstract-summary>
    <app-report-abstract-values *ngIf="reportId == 3"></app-report-abstract-values>
    <!-- <app-report-weekly-coder *ngIf="reportId == 4"></app-report-weekly-coder> -->
    <app-report-weekly-coder-consensus *ngIf="reportId == 5"></app-report-weekly-coder-consensus>
    <app-report-recon-completed *ngIf="reportId == 6"></app-report-recon-completed>
  </div>
</div>
